<template>
  <ValidationProvider ref="observer">
    <b-form-select :options="computedOptions" @change="updateData" :state="state" v-model="value" :title="value"/>
    <span style="font-size: 10px; color: #dc3545">{{ errorMsg }}</span>
  </ValidationProvider>
</template>

<script>

import {createNamespacedHelpers} from "vuex";
const {mapState: globalMapState} = createNamespacedHelpers('global');

export default {
  name: "UnsoldModalTableItem",
  props: {
    isInvoice: {
      type: Boolean,
      required: true
    },
    reservationUuid: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: false
    },
    errorMsg: {
      type: String,
      required: false
    },
    passedValue: {
      type: String,
      required: false
    }
  },
  watch: {
    passedValue(newValue) {
      if (newValue !== this.value) {
        this.value = newValue;
      }
    }
  },
  data() {
    return {
      value: null,
    }
  },
  methods: {
    updateData() {
      this.$emit('updateData', {reservation_uuid: this.reservationUuid, isInvoice: this.isInvoice, option: this.value})
    }
  },
  computed: {
    ...globalMapState({
      batchUnsoldParams: state => state.batchUnsoldParams
    }),
    computedOptions() {
      let choices = [
        {value: null, text: this.$t('Make a choice')}
      ];
      let actions = this.isInvoice ? this.batchUnsoldParams.invoice_actions : this.batchUnsoldParams.settlement_actions;
      for (let action of actions) {
        choices.push({value: action.key, text: this.$t(action.label)});
      }
      return choices;
    }
  }
}
</script>
